import Profile from "../account/component/Profile";

const MyProfile = () => {
  return (
    <div className="pt-[70px] min-h-screen">
      <Profile />
    </div>
  );
};

export default MyProfile;
